import React from 'react'
import ReactDOM from 'react-dom'
import { useSpring, animated } from 'react-spring'
import { NavLink, Link } from "react-router-dom";
import Cards11 from "./Cards_11";

const calc = (x, y) => [-(y - window.innerHeight / 2) / 20, (x - window.innerWidth / 2) / 20, 1.1]
const trans = (x, y, s) => `perspective(600px) rotateX(${x}deg) rotateY(${y}deg) scale(${s})`

/*<div className="">
<animated.div
        class="card3"
        onMouseMove={({ clientX: x, clientY: y }) => set({ xys: calc(x, y) })}
        onMouseLeave={() => set({ xys: [0, 0, 1] })}
        style={{ transform: props.xys.interpolate(trans) , backgroundImage:  'url("./pictures/images_9.jpg")' }}    
/> 

</div>*/


function Card() {
  const [props, set] = useSpring(() => ({ xys: [0, 0, 1], config: { mass: 5, tension: 350, friction: 40 } }))

  var divStyle = {
    color: 'blue',
    cursor: 'pointer',
  }
  
  return (
        <div className="">


        <div   id = "signal-report"    className="card-9" style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}   >
        <br></br>
        <a     id ="Strategy" aria-expanded="false"   ><img  width="170px" height="70px" src="./pictures/images_20.jpg"></img><span className="doc-content-title">Charts , Mapping and Indicators</span></a>
                          <div className="wrapper_line"></div>

                          <br></br>

                <p id="page_summary_id" className="page_summary_id">
                   <span>Interactive advanced intraday and daily charts are offred including candlestick charts and chartlines combined with technical indicators such as RSI (Relative Strength Index - momentum indicator) for reversal investment perspectives and ATR (Average True Range) for stop loss calibration purposes.</span>
                   <span>Our visualization ecosystem combines candlestick charting, dynamic market mapping, and structured indicator analysis within a unified trading interface optimized for multi-timeframe monitoring</span>
                  
                  <br></br>  
                  <br></br>  

                  <NavLink
                    exact
                    to="/solution"
                    cursor= "pointer"
                    style = {divStyle}
                  >
                    Learn more ...
                  </NavLink>
                
                  <br></br>  
               
                </p>

                <br></br>

                
                <Cards11 />
              <br></br>

  
        </div>


        </div>

  )
};

export default Card; 


